import {TimeTableResponse} from "./timeTable";
import instance from "./axios";


export const callGetAllExams = (semesterId: string) => instance.get<TimeTableResponse>("api/semesters/" + semesterId + "/exams");